import { gql } from "@apollo/client";
import { MutationResponseWithId } from "../../sharedTypes";

export const FEED_LOCATION = gql`
  mutation Feed($domain: String!, $locationid: Int!, $overwriteFeedcurve: Boolean!, $amount: Int!) {
    location {
      feed(domain: $domain, locationid: $locationid, overwriteFeedcurve: $overwriteFeedcurve, amount: $amount) {
        code
        success
        message
      }
    }
  }
`

export interface FeedLocation {
  domain: string
  locationid: number
  overwriteFeedcurve: boolean
  amount: number
}

interface FeedLocationAction {
  code: String
  success: Boolean
  message: string
}

export interface FeedLocationResponse {
  location: {
    feed: FeedLocationAction
  }
}


export const FEED_LOCATION_MULTIPLE = gql`
  mutation FeedMultiple($domain: String!, $locationIds: [Int!]!, $overwriteFeedcurve: Boolean!, $amount: Int!) {
    location {
      feedMultiple(domain: $domain, locationIds: $locationIds, overwriteFeedcurve: $overwriteFeedcurve, amount: $amount) {
        code
        message
        success
        id
      }
    }
  }
`

export interface FeedLocationMultiple {
  domain: string
  locationIds: number[]
  overwriteFeedcurve: boolean
  amount: number
}

export interface FeedLocationMultipleResponse {
  location: {
    feedMultiple: MutationResponseWithId[]
  }
}
